




import assetx from '@/store/modules/assetx';
import settingx from '@/store/modules/settingx';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import throttle from 'lodash/throttle';
import random from '@/util/random';
import * as PIXI from 'pixi.js';
import { Scene } from 'pixi-animate';
import { nonReact } from '@/util/nonReact';
import { Preset } from '@/game/infos/preset';
import Factory from '@/client/factory';
import { FishType } from '@/game/infos/fishInfos';
import { Global } from '@/store/globalz';
import { SoundEfx } from '@/client/sound/SoundEfx';
import { Tween } from '@/util/tweents';
import globalx from '@/store/modules/globalx';

const fxaaFilter = new PIXI.filters.FXAAFilter();
PIXI.settings.PRECISION_FRAGMENT = PIXI.PRECISION.HIGH;

const scene = nonReact(
  new Scene(
    document.documentElement.clientWidth,
    document.documentElement.clientHeight,
    {
      antialias: false,
      transparent: true,
      forceCanvas: false,
    },
    true,
  ),
);
Global.overlayCanvasStage = scene.stage;

@Component({
  components: {},
})
export default class OverlayCanvasComponent extends Vue {
  public get dpi() {
    return settingx.now.dpi;
  }
  public get frameRate() {
    return settingx.now.frameRate;
  }
  public get antialias() {
    return settingx.now.antialias === 1;
  }
  public get assetLoadState() {
    return assetx.assetLoadState;
  }
  @Prop({ default: false }) public noWebGL!: boolean;

  public width = this.$el ? this.$el.clientWidth : 0;
  public height = this.$el ? this.$el.clientHeight : 0;
  public app = scene;
  public stage = this.app.stage;
  public id = random.firestore();

  public built = false;
  public isStopped = false;

  public updateAntialiasThrottled = throttle(this.updateAntialias, 500);

  public resizeThrottled = throttle(this.resize, 500);

  @Prop({ default: false }) public bool!: boolean;
  @Prop({ default: 0 }) public showUnlock!: FishType;
  @Prop({ default: false }) public showReincarnation!: boolean;

  /** Main assets are loaded */
  public build() {
    if (!this.built) {
      this.built = true;
      if (Global.skinGachaControl) {
        Global.skinGachaControl.resize(this.width, this.height);
      }
    }
  }

  public renderAndStop() {
    this.isStopped = true;
    this.app.render();
    this.app.stop();
  }
  public rerenderAndStop() {
    this.app.start();
    this.renderAndStop();
  }

  public onResize() {
    this.width = Global.width = document.documentElement.clientWidth;
    this.height = Global.height = document.documentElement.clientHeight;
    this.resize();
    if (this.built) {
      if (Global.skinGachaControl) {
        Global.skinGachaControl.resize(this.width, this.height);
      }
    }
  }

  public mounted() {
    // if (!(this.$el as any).resizeSensor) {
    //   const res = new ResizeSensor(this.$el, this.onResize);
    // }
    window.addEventListener('resize', this.onResize);
    this.$el.appendChild(this.app.view);
    this.app.view.style.width = '100%';
    this.app.view.style.height = '100%';
    this.app.stage.filterArea = this.app.renderer.screen;
    this.onResize();
  }

  public beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
    // if ((this.$el as any).resizeSensor) {
    //   ResizeSensor.detach(this.$el);
    // }
    this.stage.removeChildren();
  }
  @Watch('assetLoadState', { immediate: true })
  public assetLoadStateChanged(newVal: 'completed' | 'loading' | 'none') {
    if (this.assetLoadState === 'completed') {
      this.build();
    }
  }
  @Watch('dpi', { immediate: true })
  public dpiChanged(newVal: number) {
    this.resizeThrottled();
  }
  @Watch('antialias', { immediate: true })
  public antialiasChanged(newVal: number) {
    this.updateAntialiasThrottled();
  }
  @Watch('frameRate', { immediate: true })
  public frameRateChanged(newVal: number) {
    this.app.ticker.maxFPS = newVal;
  }
  protected resize() {
    this._resize();
  }

  protected updateAntialias() {
    this.app.stage.filters = this.antialias ? [fxaaFilter] : [];
  }

  protected _resize() {
    const { dpi } = this;
    this.app.renderer.resize(this.width * dpi, this.height * dpi);
    this.app.stage.scale.set(dpi);
    if (assetx.assetLoadState === 'completed' && this.isStopped) {
      this.rerenderAndStop();
    }
  }
}
